module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/docs_logo.48174da1.svg";